import { AirlinesRounded as AirlinesRoundedIcon } from '../icons';
import { Typography } from '../../tailwindcomponents';
import { Public } from '../icons';
import { FunctionComponent } from "react";
import { useSelector } from 'react-redux'
import { RootState } from '../../reducer';
import ProfileImg from "../Images/ProfileImg";

type ToolDataForRow = {
  employee_id: number,
  tail_number: string,
  world_trip_name: string,
  employee_name: string,
}

const ReturnNameData: FunctionComponent<ToolDataForRow> = ({ employee_id, tail_number, world_trip_name, employee_name }) => {
  const employeeId = employee_id;
  const user = useSelector((state: RootState) => state.employees.all_employees.find(s => s.Id === employee_id));
  const userName = user?.userName.split("@")[0];

  if (employeeId === 0) {
    //Tool Was assigned to Tail
    return (
      <div className="flex items-center gap-2">
        <AirlinesRoundedIcon fontSize="1.5rem" title="Tool loaned out on tail" />
        <Typography text={tail_number} align='left' variant='body1' display="inline" />
      </div>
    )
  }
  else if (employeeId === -1) {
    //Tool was assigned to world Trip
    return (
      <div className="flex items-center gap-2">
        <Public fontSize="1.5rem" color="primary" />
        <Typography text={world_trip_name} align='left' variant='body1' display="inline" />
      </div>
    )
  }
  else {
    //Tool was assigned to employee
    return (
      <div className="flex items-center gap-2">
        <ProfileImg userName={userName} imgSize="xs" />
        <Typography text={employee_name} align='left' variant='body1' display="inline" />
      </div>
    )
  }
}

export default ReturnNameData;